import {styled} from "@mui/material/styles";
import {Accordion} from "@mui/material";

export const FilterAccordion = styled(Accordion)(({theme}) => ({
    boxShadow: 'none',
    borderRadius: 3,
    borderColor: theme.palette.divider,
    borderWidth: 1,
    borderStyle: 'solid',

    '& .MuiAccordionSummary-expandIconWrapper': {
        [theme.breakpoints.down('xs')]: {
            position: 'absolute',
            right: '12px',
            top: '5px',
        },
    }
}));